<template>
  <v-container v-if="isLoaded">
    <v-card>
      <v-card-title>
        View corporate brands
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="tableHeaders"
        :items="corporateBrands"
        :items-per-page="50">

        <template v-slot:item.refresh="{ item }">
          <v-btn icon @click="refresh(item)">
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </template>

      </v-data-table>
    </v-card>
    <base-dialog-ok
      label="Entity has been refresh!"
      :dialog="refreshDialog"
      @ok="() => refreshDialog = false"/>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import BaseDialogOk from '@/base/dialog/BaseDialogOk'

export default {
  name: 'ViewCorporateBrands',
  components: { BaseDialogOk },
  data () {
    return {
      isLoaded: false,
      search: '',
      refreshDialog: false,
      tableHeaders: [
        { text: 'Name', align: 'start', sortable: true, value: 'name' },
        { text: 'Id', sortable: true, value: 'corporateBrandId' },
        { text: 'Active', sortable: true, value: 'active' },
        { text: 'Refresh', align: 'start', sortable: false, value: 'refresh' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'corporateBrands',
      'getUserRoles'
    ]),
    _headers () {
      if (!this.isTechAdmin(this.getUserRoles)) {
        return this.tableHeaders.filter(header => header.text !== 'Refresh')
      }
      return this.tableHeaders
    }
  },
  async mounted () {
    await this.$store.dispatch('getAllCorporateBrands').then(() => { this.isLoaded = true })
  },
  methods: {
    refresh (brand) {
      return axios.get('/api/touchpoint/corporateBrand/refresh/' + brand.corporateBrandId)
        .then(response => {
          const index = this.corporateBrands.findIndex(pm => pm.corporateBrandId === response.data.corporateBrandId)
          this.corporateBrands.splice(index, 1, response.data)
          this.refreshDialog = true
        })
        .catch(e => console.log(e))
    }
  }
}
</script>
